import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation'

//* Helpers
import { getParamsByKey } from '@/helpers/_functions';

//* Components
import FormItem from '@/components/common/Form/FormItem';
import FormSelect from '@/components/common/Form/FormSelect';
import FormContainer from '@/components/common/Form/FormContainer';

const options = [
    { name: 'Sort by latest', value: 'Sort by latest', id: 'latest' },
    { name: 'Sort by popularity', value: 'Sort by popularity', id: 'popularity' },
    { name: 'Sort by average rating', value: 'Sort by average rating', id: 'avg-rating' },
    { name: 'Sort by price: low to high', value: 'Sort by price: low to high', id: 'price-asc' },
    { name: 'Sort by price: high to low', value: 'Sort by price: high to low', id: 'price-desc' },
];

const SortBy = ({ onFilterChange }) => {
    const searchParams = useSearchParams()

    const sortByValue = useMemo(() => {
        const activeItems = getParamsByKey(searchParams, 'sort')

        return activeItems?.[0] || 'latest'
    }, [searchParams])

    return (
        <div className='sort-by'>
            <FormContainer
                initialValues={{
                    sort_by: sortByValue,
                }}>
                <FormItem
                    name={'sort_by'}
                    required={false}>
                    <FormSelect
                        list={options}
                        placeholder={'filter'}
                        onChange={(val) => onFilterChange('sort', val)}
                    />
                </FormItem>
            </FormContainer>
        </div>
    )
}

export default SortBy